import './App.css'
import { createRef, useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { BrowserRouter as Router, Switch } from 'react-router-dom'
import LogSignIn from './pages/LogSignIn/LogSignIn'
import ModifsInfosPerso from './pages/ModifsInfosPerso/ModifsInfosPerso'
import MesActivites from './pages/MesActivites/MesActivites'
import CoursEnLigne from './pages/CoursEnLigne/CoursEnLigne'
import Contact from './pages/Contact/Contact'
import Navbar from './components/Navbar/Navbar'
import Footer from './components/Footer/footer'
import NewPassword from './pages/NewPassword/NewPassword'
import Accueil from './pages/Accueil/Accueil'
import ReservationTennis from './pages/ReservationTennis/ReservationTennis'
import { SnackbarProvider } from 'notistack'
import CustomRoute from './services/auth'
import NewSouscription from './pages/NewSouscription/NewSouscription'
import { Route, Redirect } from 'react-router-dom'
import Alert from '@material-ui/lab/Alert'
import RattachementVerification from './pages/RattachementVerification'
import NumeroOublie from './pages/NumeroOublie/NumeroOublie'
import ChangeMail from './pages/ChangeMail'
import allActions from './redux/actions/user'
import { useDispatch } from 'react-redux'

import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import { useSelector } from 'react-redux'
import background from './assets/images/nice.png'
import Interruption from './pages/Interruption/Interruption'
import Appointment from './pages/Appointment/create/Appointment'
import MyAppointment from './pages/Appointment/MyAppointment'
import Home from './pages/HomeNotConnected/Home'
import DetailsProfesseurs from './pages/DetailsProfesseurs/DetailsProfesseurs';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundImage: `url(${background})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
  },
}))

function App() {

  const dispatch = useDispatch()
  const [interruption, setInterruption] = useState({ value: false })

  async function fetchInterruption() {
    const { json } = await allActions.fetchGetAPI('api/interruption/', dispatch)
    dispatch(allActions.setInterruptTennis(json?.interruption_tennis))
    dispatch(allActions.setInterruptX10(json?.interruption_x10))
    dispatch(allActions.setInterruptSaison(json?.interruption_saison))
    dispatch(allActions.setInterruptRenouvellementSaison(json?.interruption_renouvellement_saison))
    dispatch(allActions.setSocialNetworks(json?.social_networks))
    dispatch(allActions.setInterruptRendezVous(json?.interruption_rendez_vous))

    if(!!json?.interruption) setInterruption({ value: true, message: json.message })
  }

  if(interruption.value === false) fetchInterruption()

  useEffect(() => {
    const sc = document.createElement('script')
    sc.src = process.env.REACT_APP_PAYZEN_DOMAIN_URL

    let key = process.env.REACT_APP_PUBLIC_KEY
    if (process.env.REACT_APP_MODE === 'TEST') key = process.env.REACT_APP_PUBLIC_KEY_TEST
    if (process.env.REACT_APP_MODE === 'PROD') key = process.env.REACT_APP_PUBLIC_KEY_PROD    

    sc.setAttribute('kr-public-key', key)
    document.head.appendChild(sc)

    return () => {
      document.head.removeChild(sc)
    }
  }, [])
  
  const classes = useStyles()
  const completedData = useSelector(state => state.completedData)
  const loggedIn = useSelector(state => state.loggedIn)
  const notistackRef = createRef()
  const onClickDismiss = key => () => {
    notistackRef.current.closeSnackbar(key)
  }

  const isAuthenticated = () => {
    return loggedIn
  }

  return (
    <Router>
      <SnackbarProvider
        ref={notistackRef}
        action={(key) => (<IconButton onClick={onClickDismiss(key)}><CloseIcon color="secondary" /></IconButton>)}
        maxSnack={3}
        autoHideDuration={7000}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
        <div className={classes.root + ' App'} >

          {interruption.value ? <>
            <Interruption message={interruption.message} />
          </> : (<>
            <Navbar />
            <Switch>
              <CustomRoute exact path="/" component={isAuthenticated() ? Accueil : Home} />
              <CustomRoute path="/login" exact component={LogSignIn} />
              <CustomRoute exact path="/professeurs/details/:id" component={DetailsProfesseurs} />
              <CustomRoute exact path="/nouveau-mdp/:token" component={NewPassword} />
              <CustomRoute protect="true" exact path="/cours" component={CoursEnLigne} />
              <CustomRoute protect="true" exact path="/reservation-tennis" component={ReservationTennis} />
              <CustomRoute protect="true" exact path="/donnees-personnelles" component={ModifsInfosPerso} />
              <CustomRoute protect="true" exact path="/mes-activites" component={MesActivites} />
              <Route exact path="/contact" component={Contact} />
              {/* <CustomRoute protect="true" exact path="/souscription" component={Souscription} /> */}
              <CustomRoute protect="true" exact path="/souscription" component={NewSouscription} />
              <CustomRoute protect="true" exact path="/rendez-vous" component={Appointment} />
              <CustomRoute protect="true" exact path="/mes-rendez-vous" component={MyAppointment} />
              <CustomRoute exact path="/numero-oublie" component={NumeroOublie} />
              <CustomRoute exact path="/rattachement/:token" component={RattachementVerification} />
              <CustomRoute exact path="/changemail/:token" component={ChangeMail} />
              <Route exact path="**" render={() => <Redirect to='/' />} />
            </Switch>
            {(completedData === false) &&
                        <Alert severity="warning"
                          style={{ position: 'absolute', top: 80, width: '100%' }}>
                          <strong>Veuillez compléter vos données personnelles</strong> afin d'effectuer une souscription ou une reservation
                        </Alert>
            }
            <Footer />
          </>)}
          
        </div>
      </SnackbarProvider>
    </Router>
  )
}

export default App
